module.exports = __webpack_public_path__ + "static/logo-ins-6750b4934bf0b1e4b117e90283c58707.png";